import {useParams} from "react-router-dom";
import React from "react";
import BoxActivity from "./BoxActivity/BoxActivity";

function GetUuidBoxActivity () {
    let {uuid} = useParams()
    return (
        <BoxActivity uuid={uuid}/>
    )
}

export default GetUuidBoxActivity;
